import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

// Chain info
export const getChainInfo = () => api.get('/');

// Blocks
export const getBlocks = (page = 1, limit = 20) => 
  api.get('/blocks', { params: { page, limit } });

export const getBlock = (identifier) => 
  api.get(`/blocks/${identifier}`);

export const getBlockTransactions = (height) => 
  api.get(`/blocks/${height}/transactions`);

// Transactions
export const getTransactions = (page = 1, limit = 20) => 
  api.get('/transactions', { params: { page, limit } });

export const getTransaction = (hash) => 
  api.get(`/transactions/${hash}`);

// Addresses
export const getAddress = (address) => 
  api.get(`/address/${address}`);

export const getAddressTransactions = (address, page = 1, limit = 20) => 
  api.get(`/address/${address}/transactions`, { params: { page, limit } });

// Network stats
export const getNetworkStats = () => api.get('/stats');

// Tokenomics
export const getTokenomics = () => api.get('/tokenomics');

// Mempool
export const getMempool = (limit = 50) => 
  api.get('/mempool', { params: { limit } });

// Search
export const search = (query) => 
  api.get('/search', { params: { q: query } });

// Validators
export const getValidators = () => api.get('/validators');

// Miners
export const getMiners = () => api.get('/miners');

export default api;
